/**
 * An Error subclass that carries structured context alongside the message.
 *
 * The message stays short and readable. The context object is surfaced as
 * Sentry "extra" data (see sentry.ts beforeSend) so fields are individually
 * searchable, rather than being a JSON blob inside the message string.
 *
 * @example
 * throw new ContextualError("Parameter not found", {
 *   parameter,
 *   objective
 * });
 */
export class ContextualError extends Error {
  readonly context: Record<string, unknown>;

  constructor(message: string, context: Record<string, unknown>) {
    super(message);
    this.context = context;
  }
}
